import "@/App.css";
import { useLenis } from "@/components/site/useLenis";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { MenuSection } from "@/components/site/MenuSection";
import { WhyUs } from "@/components/site/WhyUs";
import { Reviews } from "@/components/site/Reviews";
import { InstagramSection } from "@/components/site/InstagramSection";
import { LocationSection } from "@/components/site/LocationSection";
import { Footer } from "@/components/site/Footer";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";

function App() {
    useLenis();
    return (
        <div className="App">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <MenuSection />
                <WhyUs />
                <Reviews />
                <InstagramSection />
                <LocationSection />
            </main>
            <Footer />
            <FloatingWhatsApp />
        </div>
    );
}

export default App;
